import React from "react";

// Веб-страница тарифов, полностью аналогичная мобильной версии
export default function TarifPage() {
    return (
        <main
            style={{
                display: "flex",
                justifyContent: "center",
                overflow: "auto",
                backgroundColor: "transparent",
                padding: "20px 10px",
            }}
        >
            <section
                style={{
                    width: "100%",
                    maxWidth: "900px",
                    borderRadius: "16px",
                    padding: "24px",
                    color: "#2C3E50",
                    boxShadow: "0 6px 30px rgba(16,61,100,0.06)",
                    lineHeight: "1.6",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#fff",
                    height: "fit-content",
                }}
            >
                {/* Заголовок */}
                <h1
                    style={{
                        fontSize: "26px",
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: "#103d64",
                    }}
                >
                    Условия доставки
                </h1>

                {/* Линия */}
                <div style={{ border: "none", height: "3px", backgroundColor: "#103d64", width: "100px", marginBottom: "20px" }} />

                {/* Важная информация о коробках */}
                <div
                    style={{
                        backgroundColor: "#F4F7F9",
                        padding: "16px",
                        borderRadius: "12px",
                        borderLeft: "4px solid #103d64",
                        marginBottom: "24px",
                        fontSize: "16px",
                    }}
                >
                    <p style={{ marginBottom: "12px" }}>
                        Доставка посылок в коробках выходит дороже, так как учитывается объемный вес.
                    </p>
                    <p style={{ marginBottom: "12px" }}>
                        Для оптимизации стоимости доставки переупаковка из коробок в пакеты на складах производится на все, кроме товаров, которые могут повредиться при транспортировке без коробки (техника, хрупкое и пр).
                    </p>
                    <p style={{ marginBottom: 0 }}>
                        Если нужна брендовая коробка от обуви или сумок/рюкзаков, в Приложении внизу в углу справа нажмите{" "}
                        <strong>«Профиль»</strong>, далее нажмите <strong>«Правила переупаковки»</strong> и выберите{" "}
                        <strong>«Оставить как есть»</strong>.
                    </p>
                </div>

                {/* Блок: Тариф без коробок */}
                <div style={{ marginBottom: "24px" }}>
                    <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#103d64", marginBottom: "10px" }}>
                        🏷️ Тариф для заказов без коробок:
                    </h2>
                    <ul style={{ listStyleType: "none", paddingLeft: "8px", margin: "0 0 6px 0", fontSize: "18px" }}>
                        <li style={{ marginBottom: "4px" }}>
                            • США — <strong>99 сом</strong>
                        </li>
                        <li>
                            • Испания — <strong>110 сом</strong>
                        </li>
                    </ul>
                    <p style={{ fontSize: "15px", color: "#7F8C8D", fontStyle: "italic", margin: 0 }}>
                        за каждые 100 г физического веса.
                    </p>
                </div>

                {/* Блок: Тариф в коробках */}
                <div style={{ marginBottom: "24px" }}>
                    <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#103d64", marginBottom: "10px" }}>
                        📦 Тариф для заказов в коробках:
                    </h2>

                    <p style={{ fontSize: "16px", marginBottom: "12px" }}>
                        Стоимость доставки считается по физическому и объёмному весу.
                    </p>

                    {/* Формула объемного веса */}
                    <div
                        style={{
                            backgroundColor: "#EBF3F9",
                            padding: "14px",
                            borderRadius: "10px",
                            textAlign: "center",
                            margin: "10px 0",
                        }}
                    >
                        <p style={{ fontSize: "14px", color: "#5A738E", fontWeight: "600", margin: "0 0 4px 0" }}>
                            Формула объемного веса:
                        </p>
                        <p style={{ fontSize: "18px", fontWeight: "700", color: "#103d64", margin: 0 }}>
                            (длина × ширина × высота) / 6000
                        </p>
                    </div>

                    <h3
                        style={{
                            fontWeight: "700",
                            fontSize: "18px",
                            color: "#103d64",
                            marginTop: "15px",
                            marginBottom: "5px",
                        }}
                    >
                        Расчёт стоимости:
                    </h3>

                    <p style={{ fontSize: "16px", marginBottom: "12px" }}>
                        Если объёмный вес больше физического, дополнительно оплачивается по{" "}
                        <strong>60 сом за каждые 100 г</strong> превышения объёмного веса над физическим весом для обеих стран. Авиалинии нам выставляют за доставку по такому же принципу.
                    </p>

                    {/* Примечание зелёное */}
                    <div
                        style={{
                            backgroundColor: "#E8F8F5",
                            padding: "12px",
                            borderRadius: "8px",
                            borderLeft: "4px solid #2ECC71",
                            marginTop: "15px",
                        }}
                    >
                        <p style={{ fontSize: "15px", color: "#16A085", fontWeight: "600", lineHeight: "22px", margin: 0 }}>
                            👉 Если объёмный вес равен или меньше физического — оплачивается по физическому весу.
                        </p>
                    </div>
                </div>
            </section>
        </main>
    );
}